import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-material-input-demo',
  templateUrl: './material-input-demo.component.html',
  styleUrls: ['./material-input-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialInputDemoComponent implements OnInit {
  smallEmpty = new FormControl<string>(null, []);
  smallValue = new FormControl<string>('Vitodens 300', []);
  smallError = new FormControl<string>('Vitodens 300', [Validators.pattern(/^\d+$/)]);

  mediumEmpty = new FormControl<string>(null, []);
  mediumValue = new FormControl<string>('Vitodens 300', []);
  mediumError = new FormControl<string>('Vitodens 300', [Validators.pattern(/^\d+$/)]);

  largeEmpty = new FormControl<string>(null, []);
  largeValue = new FormControl<string>('Vitodens 300', []);
  largeError = new FormControl<string>('Vitodens 300', [Validators.pattern(/^\d+$/)]);

  constructor() {}

  ngOnInit(): void {
    this.smallError.setErrors({ pattern: true });
    this.smallError.markAsTouched();

    this.mediumError.setErrors({ pattern: true });
    this.mediumError.markAsTouched();

    this.largeError.setErrors({ pattern: true });
    this.largeError.markAsTouched();
  }

  clear(form: FormControl): void {
    form.setValue('');
  }
}
